module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAaCAYAAAAwspV7AAABYUlEQVR4AWJ4pqug8VRVtoQQfqImlwbEzuTgp6pyro9V5fIJ2fFYXS7/v7EgP6DdMuCIIAri+H6P+08hO3NLnyH6FAUIIAEIEAABBQ7EAYoSRIUq4T5AUUUlb7auinCFENW2+xy29zo6p+Xe8oP9z878rGd2IxW8G8ZnVVCm66h7Q/DsQxlvtuY8Y6+MCu5sn9NyZrnPBwpe/XOo812TCp10paJfLhVqFE1p1pkzNfO8TjOefDXPE5r2zkhowr6po3+VClJBygguMg7KKKNd5HTmyg3XHgYm1Q8Dk9KYlm5ldLKMMu0UOwaLrjzlkf2+pMJBD1JBivGkTFcOOrbPoytPGS9DtqeEFnScxsoYwYbdU/POnLEVDnqQqoSUibHsQxnHdiWsKNPUD2Ic2g92w5VnWcs+v+2dI1i3v0etSBkfVqwiUDuTqjVVYHrCuNQ6NlVo7Q/sGqGbXjMMZzUJzX0BFqYjsF2zxNkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/money-tray-icon.png
// module id = 481
// module chunks = 0